<section class="faq ">
  <div class="container">
    <div class="row mb-2 justify-content-center">
      <div class=" faq-wraper">
        <div class="questions-div">
          <h2 class="para1">{{"faq-para1" | translate}}</h2>
          <h2 class="para2">{{"faq-para2" | translate}}</h2>
          <p class="para3">{{"faq-para3" | translate}}</p>
          <p class="para3">{{"faq-para4" | translate}}</p>
        </div>
        <div class='accord-div'>
          <div *ngFor="let item of data; let i = index;">
            <div class="accordion-wrapper">
            </div>
            <button class="accordion click" (click)="toggleAccordian($event, i)">
              {{item.parentName | translate}}
            </button>
            <div class="panel" hide="!item.isActive">
              <p *ngFor="let child of item.childProperties" class="fw-regular font-16 px-4 ">
                <span [innerHTML]="(child.propertyName | translate) | dynamicLink: child.links"></span>
                <!-- {{child.propertyName | translate }} -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <div class="text-center pb-5 px-3"> -->
<!-- <img src="/assets/images/new/nextgen-avtar.svg" class="img-fluid" alt=""> -->
<!-- <ng-lottie [styles]="styles" [options]="options" (animationCreated)="onAnimate($event)">
  </ng-lottie> -->
<!-- </div> -->